import PasswordInput from '../components/PasswordInput';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '—';
const durumRenk = { bekliyor: 'badge-bekliyor', onay_sureci: 'badge-bekliyor', onaylandi: 'badge-tamamlandi', reddedildi: 'badge-hata', revize: 'badge-bekliyor' };
const durumEtiket = { bekliyor: 'Bekliyor', onay_sureci: 'Onay Sürecinde', onaylandi: 'Onaylandı', reddedildi: 'Reddedildi', revize: '↩ Revize İstendi' };

const BilgiSatiri = ({ ikon, label, value }) => (
  <div style={{ display: 'flex', gap: '10px', padding: '8px 10px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)' }}>
    <span style={{ fontSize: '15px', flexShrink: 0 }}>{ikon}</span>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '2px' }}>{label}</div>
      <div style={{ fontSize: '13px', fontWeight: '500', wordBreak: 'break-word' }}>{value || '—'}</div>
    </div>
  </div>
);

const ProfilimPage = () => {
  const { kullanici } = useAuth();
  const [veri, setVeri] = useState(null);
  const [sekme, setSekme] = useState(() => {
    const path = window.location.pathname;
    const alt = path.split('/')[2];
    return ['bilgiler','istihdam','performans','izinler','zimmetler','sifre','guvenlik'].includes(alt) ? alt : 'bilgiler';
  });

  React.useEffect(() => {
    document.title = 'Profilim - Valure HR';
  }, [sekme]);

  React.useEffect(() => {
    const handlePop = () => {
      const alt = window.location.pathname.split('/')[2];
      if (alt && ['bilgiler','istihdam','performans','izinler','zimmetler','sifre','guvenlik'].includes(alt)) {
        setSekme(alt);
      }
    };
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);
  const [kisiselForm, setKisiselForm] = useState({});
  const [kisiselDuzenle, setKisiselDuzenle] = useState(false);
  const [sifreForm, setSifreForm] = useState({ mevcut_sifre: '', yeni_sifre: '', tekrar: '' });
  const [izinForm, setIzinForm] = useState({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' });
  const [izinTurleri, setIzinTurleri] = useState([]);
  const [yeniIzinPanel, setYeniIzinPanel] = useState(false);
  const [duzenleIzinId, setDuzenleIzinId] = useState(null);
  const [duzenleIzinForm, setDuzenleIzinForm] = useState({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' });
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [performansYil, setPerformansYil] = useState(new Date().getFullYear());
  const [twofaDurum, setTwofaDurum] = useState(false);
  const [twofaQr, setTwofaQr] = useState(null);
  const [twofaSecret, setTwofaSecret] = useState(null);
  const [twofaKod, setTwofaKod] = useState('');
  const [twofaAktifKod, setTwofaAktifKod] = useState('');
  const [twofaAdim, setTwofaAdim] = useState('baslangic');
  const [zimmetler, setZimmetler] = useState([]);

  const yukle = () => {
    axios.get('/api/personel/profil').then(r => { setVeri(r.data); setKisiselForm(r.data.profil || {}); }).catch(console.error);
    axios.get('/api/admin/dinamik-listeler/izin_turleri').then(r => setIzinTurleri(r.data)).catch(console.error);
    axios.get('/api/twofa/durum').then(r => setTwofaDurum(r.data.aktif)).catch(console.error);
  };

  useEffect(() => {
    yukle();
    if (kullanici?.id) {
      axios.get('/api/zimmet/personel/' + kullanici.id).then(r => setZimmetler(r.data)).catch(() => {});
    }
  }, []);

  const handleKisiselKaydet = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try { await axios.put('/api/personel/profil', kisiselForm); setSonuc({ tip: 'basari', mesaj: 'Bilgileriniz guncellendi.' }); setKisiselDuzenle(false); yukle(); }
    catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleSifre = async (e) => {
    e.preventDefault();
    if (sifreForm.yeni_sifre !== sifreForm.tekrar) { setSonuc({ tip: 'hata', mesaj: 'Yeni sifreler eslemiyor.' }); return; }
    setYukleniyor(true); setSonuc(null);
    try { await axios.put('/api/personel/sifre', { mevcut_sifre: sifreForm.mevcut_sifre, yeni_sifre: sifreForm.yeni_sifre }); setSonuc({ tip: 'basari', mesaj: 'Sifreniz guncellendi.' }); setSifreForm({ mevcut_sifre: '', yeni_sifre: '', tekrar: '' }); }
    catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleIzinGonder = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try { await axios.post('/api/personel/izinler', izinForm); setSonuc({ tip: 'basari', mesaj: 'Izin talebiniz olusturuldu.' }); setIzinForm({ izin_turu: '', baslangic_tarihi: '', bitis_tarihi: '', aciklama: '' }); setYeniIzinPanel(false); yukle(); }
    catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleIzinIptal = async (id) => {
    if (!window.confirm('Iptal etmek istediginize emin misiniz?')) return;
    try { await axios.delete('/api/personel/izinler/' + id); yukle(); }
    catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Iptal edilemedi.' }); }
  };

  const handleIzinDuzenleAc = (izin) => {
    setDuzenleIzinForm({ izin_turu: izin.izin_turu, baslangic_tarihi: izin.baslangic_tarihi, bitis_tarihi: izin.bitis_tarihi, aciklama: izin.aciklama || '' });
    setDuzenleIzinId(izin.id);
    setYeniIzinPanel(false);
    setTimeout(() => { document.getElementById('revize-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
  };

  const handleIzinGuncelleVeGonder = async () => {
    try {
      await axios.put('/api/personel/izinler/' + duzenleIzinId, duzenleIzinForm);
      await axios.post('/api/personel/izinler/' + duzenleIzinId + '/yeniden-gonder');
      setSonuc({ tip: 'basari', mesaj: 'Talep güncellendi ve yeniden onaya gönderildi.' });
      setDuzenleIzinId(null);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
  };

  const gunHesapla = () => {
    if (!izinForm.baslangic_tarihi || !izinForm.bitis_tarihi) return 0;
    return Math.max(0, Math.ceil((new Date(izinForm.bitis_tarihi) - new Date(izinForm.baslangic_tarihi)) / (1000*60*60*24)) + 1);
  };

  if (!veri) return <div style={{ padding: '2rem', color: 'var(--yazi-ikincil)' }}>Yukleniyor...</div>;

  const { kullanici: k, profil, istihdam, performanslar = [], izinler = [] } = veri;
  const mevcutPerformans = performanslar.find(p => p.yil === performansYil);
  const aktifZimmetler = zimmetler.filter(z => z.durum === 'aktif');
  const gecmisZimmetler = zimmetler.filter(z => z.durum === 'iade');

  const sekmeler = [
    { key: 'bilgiler', label: '👤 Bilgiler' },
    { key: 'istihdam', label: '💼 Istihdam' },
    { key: 'performans', label: '📊 Performans' },
    { key: 'izinler', label: `🏖️ Izinler (${izinler.length})` },
    { key: 'zimmetler', label: `🖥️ Zimmetler${aktifZimmetler.length > 0 ? ` (${aktifZimmetler.length})` : ''}` },
    { key: 'sifre', label: '🔑 Sifre' },
    { key: 'guvenlik', label: '🛡️ 2FA' },
  ];

  return (
    <div>
      {/* Profil Banner */}
      <div className="card" style={{ marginBottom: '1.5rem', background: 'linear-gradient(135deg, var(--mavi) 0%, var(--mavi-koyu) 100%)', border: 'none' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <div className="avatar" data-harf={k?.ad?.[0]} style={{ width: '64px', height: '64px', fontSize: '22px', background: 'rgba(255,255,255,0.2)', color: 'white', flexShrink: 0 }}>
            {k?.ad?.[0]}{k?.soyad?.[0]}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '4px', color: 'white' }}>{k?.ad} {k?.soyad}</h2>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)', marginBottom: '8px' }}>
              {profil?.pozisyon || '—'} {profil?.departman ? '· ' + profil?.departman : ''}
            </p>
            <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: 'rgba(255,255,255,0.7)', flexWrap: 'wrap' }}>
              <span>✉️ {k?.email}</span>
              {profil?.telefon && <span>📞 {profil?.telefon}</span>}
              {istihdam?.ise_giris_tarihi && <span>📅 {fmt(istihdam?.ise_giris_tarihi)} tarihinden beri</span>}
            </div>
          </div>
          <div style={{ flexShrink: 0 }}>
            {istihdam?.outsource ? <span className="badge" style={{ background: 'rgba(255,255,255,0.2)', color: 'white' }}>Outsource</span> : <span className="badge" style={{ background: 'rgba(255,255,255,0.2)', color: 'white' }}>Dahili</span>}
          </div>
        </div>
      </div>

      {/* İstatistikler */}
      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{izinler.filter(i => i.durum === 'bekliyor').length}</div><div className="stat-etiket">Bekleyen Izin</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{izinler.filter(i => i.durum === 'onaylandi').reduce((t, i) => t + (i.gun_sayisi || 0), 0)}</div><div className="stat-etiket">Onayli Gun</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{mevcutPerformans?.genel_not || '—'}</div><div className="stat-etiket">{new Date().getFullYear()} Performans</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: twofaDurum ? 'var(--yesil)' : 'var(--kirmizi)' }}>{twofaDurum ? '✓' : '✗'}</div><div className="stat-etiket">2FA Durumu</div></div>
      </div>

      {/* Sekmeler */}
      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: '1.5rem', overflowX: 'auto' }}>
        {sekmeler.map(s => (
          <button key={s.key} type="button" onClick={() => { setSekme(s.key); setSonuc(null); setKisiselDuzenle(false); setYeniIzinPanel(false); setDuzenleIzinId(null); }}
            style={{ padding: '0.6rem 1.25rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap', fontWeight: sekme === s.key ? '600' : '400', color: sekme === s.key ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: sekme === s.key ? '2px solid var(--mavi)' : '2px solid transparent' }}>
            {s.label}
          </button>
        ))}
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {/* BİLGİLER */}
      {sekme === 'bilgiler' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '30px', height: '30px', borderRadius: '6px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>👤</div>
                <span style={{ fontWeight: '600', fontSize: '14px' }}>Kisisel Bilgiler</span>
              </div>
              {!kisiselDuzenle && <button className="btn btn-secondary btn-sm" onClick={() => setKisiselDuzenle(true)}>Duzenle</button>}
            </div>
            {!kisiselDuzenle ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <BilgiSatiri ikon="📞" label="Telefon" value={profil?.telefon} />
                <BilgiSatiri ikon="🎂" label="Dogum Tarihi" value={fmt(profil?.dogum_tarihi)} />
                <BilgiSatiri ikon="📍" label="Adres" value={profil?.adres} />
                <BilgiSatiri ikon="🆘" label="Acil Iletisim" value={profil?.acil_iletisim_ad} />
                <BilgiSatiri ikon="📱" label="Acil Telefon" value={profil?.acil_iletisim_tel} />
              </div>
            ) : (
              <form onSubmit={handleKisiselKaydet}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <div className="form-group"><label>Telefon</label><input type="tel" value={kisiselForm.telefon || ''} onChange={e => setKisiselForm({ ...kisiselForm, telefon: e.target.value })} /></div>
                  <div className="form-group"><label>Dogum Tarihi</label><input type="date" value={kisiselForm.dogum_tarihi || ''} onChange={e => setKisiselForm({ ...kisiselForm, dogum_tarihi: e.target.value })} /></div>
                  <div className="form-group"><label>Adres</label><textarea value={kisiselForm.adres || ''} onChange={e => setKisiselForm({ ...kisiselForm, adres: e.target.value })} rows={2} /></div>
                  <div className="form-group"><label>Acil Iletisim</label><input type="text" value={kisiselForm.acil_iletisim_ad || ''} onChange={e => setKisiselForm({ ...kisiselForm, acil_iletisim_ad: e.target.value })} /></div>
                  <div className="form-group"><label>Acil Telefon</label><input type="tel" value={kisiselForm.acil_iletisim_tel || ''} onChange={e => setKisiselForm({ ...kisiselForm, acil_iletisim_tel: e.target.value })} /></div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => { setKisiselDuzenle(false); setKisiselForm(profil || {}); }}>Iptal</button>
                </div>
              </form>
            )}
          </div>
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '6px', background: 'var(--yesil-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>💼</div>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>Is Bilgileri</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <BilgiSatiri ikon="🏢" label="Departman" value={profil?.departman} />
              <BilgiSatiri ikon="🎯" label="Pozisyon" value={profil?.pozisyon} />
              <BilgiSatiri ikon="📅" label="Ise Giris" value={fmt(istihdam?.ise_giris_tarihi)} />
              <BilgiSatiri ikon="🏠" label="Istihdam Turu" value={istihdam?.outsource ? 'Outsource' : 'Dahili'} />
              {istihdam?.outsource_firma && <BilgiSatiri ikon="🤝" label="Outsource Firma" value={istihdam?.outsource_firma} />}
            </div>
          </div>
        </div>
      )}

      {/* İSTİHDAM */}
      {sekme === 'istihdam' && (
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <div style={{ width: '30px', height: '30px', borderRadius: '6px', background: 'var(--sari-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>💼</div>
            <span style={{ fontWeight: '600', fontSize: '14px' }}>Istihdam Bilgileri</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            <BilgiSatiri ikon="💰" label="Maas" value={istihdam?.maas ? Number(istihdam.maas).toLocaleString('tr-TR') + ' TL' : null} />
            <BilgiSatiri ikon="📅" label="Ise Giris" value={fmt(istihdam?.ise_giris_tarihi)} />
            <BilgiSatiri ikon="🏠" label="Istihdam Turu" value={istihdam?.outsource ? 'Outsource' : 'Dahili'} />
            <BilgiSatiri ikon="🤝" label="Outsource Firma" value={istihdam?.outsource_firma} />
            <BilgiSatiri ikon="📅" label="Musteride Baslangic" value={fmt(istihdam?.outsource_baslangic)} />
          </div>
        </div>
      )}

      {/* PERFORMANS */}
      {sekme === 'performans' && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <select value={performansYil} onChange={e => setPerformansYil(parseInt(e.target.value))} style={{ width: 'auto' }}>
              {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          {mevcutPerformans ? (
            <div className="card">
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '1.25rem' }}>
                <div style={{ background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)', padding: '1.25rem', textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'var(--mavi)' }}>{mevcutPerformans.genel_not || '—'}</div>
                  <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>/ 100 Genel Not</div>
                </div>
                <div style={{ background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', padding: '1.25rem', textAlign: 'center' }}>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: 'var(--yesil)' }}>%{mevcutPerformans.zam_orani || '—'}</div>
                  <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>Zam Orani</div>
                </div>
                <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '1.25rem' }}>
                  <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginBottom: '4px' }}>Notlar</div>
                  <div style={{ fontSize: '13px' }}>{mevcutPerformans.notlar || '—'}</div>
                </div>
              </div>
              {mevcutPerformans.hedefler?.length > 0 && (
                <div>
                  <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '0.75rem', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Performans Hedefleri</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    {mevcutPerformans.hedefler.map((h, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)' }}>
                        <div style={{ flex: 1, fontSize: '14px' }}>{h.hedef}</div>
                        <div style={{ width: '160px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--yazi-ikincil)', marginBottom: '3px' }}>
                            <span>Hedef: %{h.hedef_oran}</span><span>%{h.gerceklesme_oran || 0}</span>
                          </div>
                          <div style={{ background: 'var(--gri-200)', borderRadius: '99px', height: '6px' }}>
                            <div style={{ background: h.gerceklesme_oran >= h.hedef_oran ? 'var(--yesil)' : 'var(--mavi)', width: Math.min(100, h.gerceklesme_oran || 0) + '%', height: '100%', borderRadius: '99px' }} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="card" style={{ textAlign: 'center', padding: '3rem', color: 'var(--yazi-ikincil)' }}>
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>📊</div>
              {performansYil} yili icin performans kaydi bulunmuyor.
            </div>
          )}
        </div>
      )}

      {/* İZİNLER */}
      {sekme === 'izinler' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
            <div className="stats-grid" style={{ flex: 1, marginBottom: 0 }}>
              <div className="stat-kart"><div className="stat-sayi">{izinler.length}</div><div className="stat-etiket">Toplam</div></div>
              <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--sari)' }}>{izinler.filter(i => i.durum === 'bekliyor').length}</div><div className="stat-etiket">Bekliyor</div></div>
              <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{izinler.filter(i => i.durum === 'onaylandi').reduce((t, i) => t + (i.gun_sayisi || 0), 0)}</div><div className="stat-etiket">Onayli Gun</div></div>
            </div>
            <button type="button" className="btn btn-primary" onClick={() => { setYeniIzinPanel(!yeniIzinPanel); setDuzenleIzinId(null); }}>+ Yeni Talep</button>
          </div>

          {/* Revize düzenleme paneli - tablonun üstünde */}
          {duzenleIzinId && (
            <div id="revize-form" className="card" style={{ marginBottom: '1.5rem', borderLeft: '4px solid #F59E0B' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '6px', background: '#FEF3C7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}>↩</div>
                  <span style={{ fontWeight: '600', fontSize: '14px' }}>Revize — Düzenle ve Yeniden Gönder</span>
                </div>
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => setDuzenleIzinId(null)}>Kapat</button>
              </div>
              <div style={{ background: '#FEF3C7', borderRadius: '8px', padding: '10px 14px', marginBottom: '1rem', fontSize: '13px', color: '#92400E' }}>
                ⚠️ Revize istendi. Gerekli düzeltmeleri yapıp yeniden gönderin.
              </div>
              <div className="form-grid">
                <div className="form-group full">
                  <label>İzin Türü *</label>
                  <select value={duzenleIzinForm.izin_turu} onChange={e => setDuzenleIzinForm(f => ({ ...f, izin_turu: e.target.value }))}>
                    <option value="">-- Seçin --</option>
                    {izinTurleri.map(t => <option key={t.deger} value={t.deger}>{t.etiket}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Başlangıç *</label>
                  <input type="date" value={duzenleIzinForm.baslangic_tarihi} onChange={e => setDuzenleIzinForm(f => ({ ...f, baslangic_tarihi: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Bitiş *</label>
                  <input type="date" value={duzenleIzinForm.bitis_tarihi} min={duzenleIzinForm.baslangic_tarihi} onChange={e => setDuzenleIzinForm(f => ({ ...f, bitis_tarihi: e.target.value }))} />
                </div>
                <div className="form-group full">
                  <label>Açıklama</label>
                  <textarea value={duzenleIzinForm.aciklama} onChange={e => setDuzenleIzinForm(f => ({ ...f, aciklama: e.target.value }))} rows={2} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                <button type="button" className="btn btn-primary" onClick={handleIzinGuncelleVeGonder}>↩ Güncelle ve Yeniden Gönder</button>
                <button type="button" className="btn btn-secondary" onClick={() => setDuzenleIzinId(null)}>İptal</button>
              </div>
            </div>
          )}

          {/* Yeni izin formu */}
          {yeniIzinPanel && (
            <div className="card" style={{ marginBottom: '1.5rem', borderLeft: '4px solid var(--mavi)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem', paddingBottom: '0.75rem', borderBottom: '1px solid var(--border)' }}>
                <div style={{ width: '28px', height: '28px', borderRadius: '6px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🏖️</div>
                <span style={{ fontWeight: '600', fontSize: '14px' }}>Yeni Izin Talebi</span>
              </div>
              <form onSubmit={handleIzinGonder}>
                <div className="form-grid">
                  <div className="form-group full">
                    <label>Izin Turu *</label>
                    <select value={izinForm.izin_turu} onChange={e => setIzinForm({ ...izinForm, izin_turu: e.target.value })} required>
                      <option value="">-- Secin --</option>
                      {izinTurleri.map(t => <option key={t.deger} value={t.deger}>{t.etiket}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label>Baslangic *</label><input type="date" value={izinForm.baslangic_tarihi} onChange={e => setIzinForm({ ...izinForm, baslangic_tarihi: e.target.value })} required /></div>
                  <div className="form-group"><label>Bitis *</label><input type="date" value={izinForm.bitis_tarihi} min={izinForm.baslangic_tarihi} onChange={e => setIzinForm({ ...izinForm, bitis_tarihi: e.target.value })} required /></div>
                  {gunHesapla() > 0 && (
                    <div className="form-group full">
                      <div style={{ background: 'var(--mavi-acik)', borderRadius: 'var(--radius-sm)', padding: '0.6rem 1rem', fontSize: '14px', color: 'var(--mavi)', fontWeight: '600' }}>
                        📅 Toplam: {gunHesapla()} gun
                      </div>
                    </div>
                  )}
                  <div className="form-group full"><label>Aciklama</label><textarea value={izinForm.aciklama} onChange={e => setIzinForm({ ...izinForm, aciklama: e.target.value })} rows={2} /></div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Gonderiliyor...' : 'Talebi Gonder'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setYeniIzinPanel(false)}>Iptal</button>
                </div>
              </form>
            </div>
          )}

          {/* İzin listesi */}
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            {izinler.length === 0 ? (
              <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>
                <div style={{ fontSize: '32px', marginBottom: '8px' }}>🏖️</div>
                Henuz izin talebiniz bulunmuyor.
              </div>
            ) : (
              <div className="tablo-wrapper">
                <table>
                  <thead><tr><th>Izin Turu</th><th>Baslangic</th><th>Bitis</th><th>Gun</th><th>Durum</th><th>Not</th><th></th></tr></thead>
                  <tbody>
                    {izinler.map(i => (
                      <tr key={i.id}>
                        <td style={{ fontWeight: '500' }}>{i.izin_turu}</td>
                        <td style={{ fontSize: '13px' }}>{fmt(i.baslangic_tarihi)}</td>
                        <td style={{ fontSize: '13px' }}>{fmt(i.bitis_tarihi)}</td>
                        <td style={{ fontSize: '13px' }}>{i.gun_sayisi}</td>
                        <td><span className={'badge ' + (durumRenk[i.durum] || 'badge-bekliyor')}>{durumEtiket[i.durum] || i.durum}</span></td>
                        <td style={{ fontSize: '13px', color: 'var(--yazi-ikincil)', maxWidth: '160px' }}>
                          {i.onay_notu ? (
                            <span title={i.onay_notu} style={{ cursor: 'help', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {i.onay_notu}
                            </span>
                          ) : '—'}
                        </td>
                        <td>
                          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                            {['bekliyor','onay_sureci'].includes(i.durum) && (
                              <button type="button" className="btn btn-danger btn-sm" onClick={() => handleIzinIptal(i.id)}>İptal</button>
                            )}
                            {i.durum === 'revize' && (
                              <>
                                <button type="button" className="btn btn-primary btn-sm" onClick={() => handleIzinDuzenleAc(i)}>✏️ Düzenle</button>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => handleIzinIptal(i.id)}>İptal</button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ZİMMETLER */}
      {sekme === 'zimmetler' && (
        <div>
          <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '30px', height: '30px', borderRadius: '6px', background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🖥️</div>
                <span style={{ fontWeight: '600', fontSize: '14px' }}>Aktif Zimmetlerim</span>
              </div>
              <span style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: '12px', padding: '3px 10px', borderRadius: '99px', fontWeight: 700 }}>
                {aktifZimmetler.length} adet
              </span>
            </div>
            {aktifZimmetler.length === 0 ? (
              <div style={{ padding: '2.5rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>
                <div style={{ fontSize: '36px', marginBottom: '8px' }}>🖥️</div>
                <div>Üzerinize kayıtlı zimmet bulunmuyor.</div>
              </div>
            ) : (
              <div style={{ padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {aktifZimmetler.map(z => (
                  <div key={z.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', background: 'var(--gri-50)', borderRadius: '8px', padding: '12px 16px', border: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '28px', flexShrink: 0 }}>
                      {z.kategori === 'Bilgisayar' ? '💻' : z.kategori === 'Telefon' ? '📱' : z.kategori === 'Araç' ? '🚗' : '🖥️'}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>{z.zimmet_ad}</div>
                      <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>
                        {z.kategori}{z.marka ? ` · ${z.marka}` : ''}{z.model ? ` ${z.model}` : ''}{z.seri_no ? ` · SN: ${z.seri_no}` : ''}
                      </div>
                      <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>📅 Atandı: {fmt(z.atama_tarihi)}</div>
                    </div>
                    <span style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: '11px', padding: '3px 10px', borderRadius: '99px', fontWeight: 700, flexShrink: 0 }}>Aktif</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          {gecmisZimmetler.length > 0 && (
            <div className="card">
              <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)' }}>
                <span style={{ fontWeight: '600', fontSize: '14px', color: 'var(--yazi-ikincil)' }}>Geçmiş Zimmetler</span>
              </div>
              <div style={{ padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {gecmisZimmetler.map(z => (
                  <div key={z.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', opacity: 0.65 }}>
                    <div style={{ fontSize: '20px' }}>{z.kategori === 'Bilgisayar' ? '💻' : z.kategori === 'Telefon' ? '📱' : '🖥️'}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '13px', fontWeight: 600 }}><s>{z.zimmet_ad}</s></div>
                      <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>{fmt(z.atama_tarihi)} → {fmt(z.iade_tarihi)}</div>
                    </div>
                    <span style={{ background: '#F3F4F6', color: '#9CA3AF', fontSize: '11px', padding: '3px 10px', borderRadius: '99px', fontWeight: 600 }}>İade</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* ŞİFRE */}
      {sekme === 'sifre' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '6px', background: 'var(--sari-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🔑</div>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>Sifre Degistir</span>
            </div>
            <form onSubmit={handleSifre}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1rem' }}>
                <div className="form-group"><label>Mevcut Sifre *</label><PasswordInput value={sifreForm.mevcut_sifre} onChange={e => setSifreForm({ ...sifreForm, mevcut_sifre: e.target.value })} required autoComplete="current-password" /></div>
                <div className="form-group"><label>Yeni Sifre *</label><PasswordInput value={sifreForm.yeni_sifre} onChange={e => setSifreForm({ ...sifreForm, yeni_sifre: e.target.value })} required minLength={6} autoComplete="new-password" /></div>
                <div className="form-group">
                  <label>Yeni Sifre (Tekrar) *</label>
                  <PasswordInput value={sifreForm.tekrar} onChange={e => setSifreForm({ ...sifreForm, tekrar: e.target.value })} required autoComplete="new-password" />
                  {sifreForm.tekrar && sifreForm.yeni_sifre !== sifreForm.tekrar && <div style={{ fontSize: '12px', color: 'var(--kirmizi)', marginTop: '4px' }}>Sifreler eslemiyor</div>}
                  {sifreForm.tekrar && sifreForm.yeni_sifre === sifreForm.tekrar && sifreForm.tekrar.length >= 6 && <div style={{ fontSize: '12px', color: 'var(--yesil)', marginTop: '4px' }}>✓ Sifreler eslesiyor</div>}
                </div>
              </div>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ width: '100%' }}>{yukleniyor ? 'Kaydediliyor...' : 'Sifreyi Guncelle'}</button>
            </form>
          </div>
          <div className="card" style={{ background: 'var(--gri-50)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '6px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🛡️</div>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>Sifre Ipuclari</span>
            </div>
            {['En az 6 karakter kullanin', 'Buyuk ve kucuk harf karistirin', 'Rakam ve ozel karakter ekleyin', 'Sifrenizi kimseyle paylasmayın', 'Her platformda farkli sifre kullanin'].map((tip, i) => (
              <div key={i} style={{ display: 'flex', gap: '8px', fontSize: '13px', color: 'var(--yazi-ikincil)', marginBottom: '8px' }}>
                <span style={{ color: 'var(--yesil)' }}>✓</span> {tip}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 2FA */}
      {sekme === 'guvenlik' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '6px', background: twofaDurum ? 'var(--yesil-acik)' : 'var(--kirmizi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🛡️</div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '14px' }}>Iki Faktorlu Dogrulama</div>
                <div style={{ fontSize: '12px', color: twofaDurum ? 'var(--yesil)' : 'var(--kirmizi)' }}>{twofaDurum ? '✓ Aktif' : '✗ Pasif'}</div>
              </div>
            </div>
            {twofaDurum ? (
              <div>
                <div style={{ padding: '0.75rem 1rem', background: 'var(--yesil-acik)', borderRadius: 'var(--radius-sm)', marginBottom: '1.5rem', fontSize: '13px', color: 'var(--yesil)' }}>
                  ✓ Hesabiniz 2FA ile korunuyor.
                </div>
                {twofaAdim === 'deaktif' ? (
                  <div>
                    <div className="form-group" style={{ marginBottom: '1rem' }}>
                      <label>Dogrulama Kodu</label>
                      <input type="text" value={twofaAktifKod} onChange={e => setTwofaAktifKod(e.target.value)} maxLength={6} style={{ letterSpacing: '0.3em', fontSize: '20px', textAlign: 'center' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button type="button" className="btn btn-danger" onClick={async () => {
                        try { await axios.post('/api/twofa/deaktif-et', { kod: twofaAktifKod }); setTwofaDurum(false); setTwofaAdim('baslangic'); setTwofaAktifKod(''); setSonuc({ tip: 'basari', mesaj: '2FA devre disi birakildi.' }); }
                        catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata.' }); }
                      }}>Devre Disi Birak</button>
                      <button type="button" className="btn btn-secondary" onClick={() => setTwofaAdim('baslangic')}>Iptal</button>
                    </div>
                  </div>
                ) : (
                  <button type="button" className="btn btn-danger" style={{ width: '100%' }} onClick={() => setTwofaAdim('deaktif')}>2FA Devre Disi Birak</button>
                )}
              </div>
            ) : (
              <div>
                <div style={{ padding: '0.75rem 1rem', background: 'var(--kirmizi-acik)', borderRadius: 'var(--radius-sm)', marginBottom: '1.5rem', fontSize: '13px', color: 'var(--kirmizi)' }}>
                  ⚠️ Hesabiniz 2FA ile korunmuyor.
                </div>
                {twofaAdim === 'baslangic' && (
                  <button type="button" className="btn btn-primary" style={{ width: '100%' }} onClick={async () => {
                    try { const r = await axios.post('/api/twofa/kurulum'); setTwofaQr(r.data.qrCode); setTwofaSecret(r.data.secret); setTwofaAdim('qr'); }
                    catch(err) { setSonuc({ tip: 'hata', mesaj: '2FA kurulamadi.' }); }
                  }}>2FA Aktif Et</button>
                )}
                {twofaAdim === 'qr' && twofaQr && (
                  <div>
                    <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                      <img src={twofaQr} alt="QR" style={{ width: '180px', height: '180px', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)' }} />
                    </div>
                    <div style={{ background: 'var(--gri-50)', padding: '0.75rem', borderRadius: 'var(--radius-sm)', marginBottom: '1rem', fontSize: '12px', wordBreak: 'break-all' }}>
                      <div style={{ color: 'var(--yazi-ikincil)', marginBottom: '4px' }}>Manuel giris icin secret:</div>
                      <code style={{ fontWeight: '600' }}>{twofaSecret}</code>
                    </div>
                    <div className="form-group" style={{ marginBottom: '1rem' }}>
                      <label>Dogrulama Kodu *</label>
                      <input type="text" value={twofaKod} onChange={e => setTwofaKod(e.target.value)} maxLength={6} style={{ letterSpacing: '0.3em', fontSize: '20px', textAlign: 'center' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button type="button" className="btn btn-primary" disabled={twofaKod.length !== 6} onClick={async () => {
                        try { await axios.post('/api/twofa/aktif-et', { kod: twofaKod }); setTwofaDurum(true); setTwofaAdim('baslangic'); setTwofaKod(''); setTwofaQr(null); setSonuc({ tip: 'basari', mesaj: '2FA aktif edildi!' }); }
                        catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Gecersiz kod.' }); }
                      }}>Dogrula ve Aktif Et</button>
                      <button type="button" className="btn btn-secondary" onClick={() => { setTwofaAdim('baslangic'); setTwofaQr(null); setTwofaKod(''); }}>Iptal</button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="card" style={{ background: 'var(--gri-50)' }}>
            <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '1rem' }}>2FA Nedir?</div>
            <div style={{ fontSize: '13px', color: 'var(--yazi-ikincil)', lineHeight: '1.7' }}>
              Iki faktorlu dogrulama (2FA), hesabiniza giris yaparken sifrenize ek olarak bir dogrulama kodu girmenizi gerektirir.
            </div>
            <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {['Google Authenticator indirin', 'QR kodu taratın', 'Uygulama kodu girin', 'Hesabiniz koruma altinda'].map((adim, i) => (
                <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '13px' }}>
                  <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: 'var(--mavi-acik)', color: 'var(--mavi)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>{i+1}</div>
                  {adim}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ProfilimPage;
